import { useState, useEffect } from 'react';

const useSkipSsr = () => {
  const [shouldComponentRender, setShouldComponentRender] = useState(false);

  useEffect(() => setShouldComponentRender(true), []);

  return { shouldComponentRender };
};

export default useSkipSsr;
